<div *ngIf="entityTypeConfigs?.length >= 1">
  <h2 class="capitalize">Create {{selectedEntityType?.nameSingular || 'New...'}}</h2>
  <div>
    <div class="pt-0100">
      <mat-form-field class="col__ capitalize">
        <mat-label>Entity Type</mat-label>
        <mat-select [ngModel]="selectedEntityTypeConfig"
                    (ngModelChange)="setSelectedEntityTypeConfig($event)"
                    [compareWith]="compareByIdFn">
          <mat-option *ngFor="let config of entityTypeConfigs"
                      [value]="config"
                      class="capitalize">{{config.entityType.nameSingular}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <ng-container [formGroup]="formGroup"
                *ngIf="selectedEntityType && formGroup">

    <mat-accordion [displayMode]="'flat'"
                   class="flat-panels"
                   [multi]="true">
      <!-- Name Panel-->
      <mat-expansion-panel [expanded]="true"
                           (opened)="panelExpanded(PANEL_NAMES.NAME)"
                           (closed)="panelCollapsed(PANEL_NAMES.NAME)"
                           class="border-top-0 pt-0">
        <mat-expansion-panel-header [ngClass]="{ 'tempError':
                                                       formGroup.get('nameInfo').touched && !formGroup.get('nameInfo').valid }"
                                    [collapsedHeight]="'fit-content'">
          <div class="row w-100">
            <div class="col__">
              <h3>Name</h3>
            </div>
            <div class="col__">
              <!-- Summary content when collapsed-->
              <div *ngIf="isPanelCollapsed(PANEL_NAMES.NAME)">
                <div class="row row--left flexAlign--baseline recap">
                  <div class="recap__label">Name</div>
                  <div class="recap__value">
                    {{nameInfoFC?.value | fullName}}
                  </div>

                  <ng-container *ngIf="selectedEntityType.languageEnabled">
                    <div class="recap__label">
                      Languages
                    </div>
                    <div class="recap__value">
                    <app-language-list-summary [languages]="formGroup.value.entityLanguages"></app-language-list-summary>
                  </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>

        </mat-expansion-panel-header>

        <!-- Content When Expanded-->

        <div class="row w-100">
          <app-name-form class="col mb-0"
                         [entityType]="selectedEntityType"
                         formControlName="nameInfo">
          </app-name-form>
          <app-entity-duplicates class="col"
                                 (duplicateSelected)="onDuplicateSelected($event)"
                                 [currentCampaignId]="campaignId"></app-entity-duplicates>
          <app-language-form *ngIf="selectedEntityType?.languageEnabled"
                             formControlName="entityLanguages"
                             class="w-100">
          </app-language-form>
        </div>

      </mat-expansion-panel>

      <!-- Email Panel-->
      <mat-expansion-panel *ngIf="selectedEntityType.emailEnabled"
                           (opened)="panelExpanded(PANEL_NAMES.EMAILS)"
                           (closed)="panelCollapsed(PANEL_NAMES.EMAILS)"
                           [expanded]="true">
        <mat-expansion-panel-header [collapsedHeight]="'fit-content'"
                                    [ngClass]="{ 'tempError':
                                                       !formGroup.get('emails').pristine && !formGroup.get('emails').valid }">
          <div class="row w-100">
            <div class="col__">
              <h3>Emails</h3>
            </div>
            <div class="col__">
              <!-- Summary content when collapsed-->
              <div *ngIf="isPanelCollapsed(PANEL_NAMES.EMAILS)">
                <div *ngFor="let val of emailsFA.value"
                     class="row row--left flexAlign--baseline recap">
                  <div class="recap__label">{{val?.emailType}}</div>
                  <div class="recap__value truncate">
                    {{val?.email}}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </mat-expansion-panel-header>

        <!-- Content When Expanded-->
        <div formArrayName="emails">
          <ng-container *ngFor="let emailCtrl of emailsFA.controls; index as i">
            <div class="row w-100 flexWrap--nowrap mt-0050">
              <div class="col col--gutter--3">
                <app-email-form [formControlName]="i"></app-email-form>
              </div>

              <div class="col col--gutterBtn right txt-18 color--gray">
                <button mat-icon-button
                        aria-label="Remove Email"
                        (click)="removeFromFormArray(emailsFA, i)">
                  <mat-icon fontSet="fal"
                            fontIcon="fa-trash-alt">
                  </mat-icon>
                </button>
              </div>
            </div>
          </ng-container>
        </div>
        <div>
          <button type="button"
                  (click)="addToFormArray(emailsFA)"
                  class="btn btn--white pt-0075 pb-0075 w-100 mt-0050">
            <i class="fal fa-plus mr-0050"></i>
            Add Email
          </button>
        </div>
      </mat-expansion-panel>

      <!-- Phone Panel-->
      <mat-expansion-panel *ngIf="selectedEntityType.phoneNumberEnabled"
                           (opened)="panelExpanded(PANEL_NAMES.PHONES)"
                           (closed)="panelCollapsed(PANEL_NAMES.PHONES)"
                           [expanded]="true">
        <mat-expansion-panel-header [collapsedHeight]="'fit-content'"
                                    [ngClass]="{ 'tempError': !formGroup.get('phones').pristine && !formGroup.get('phones').valid }">
          <div class="row w-100">
            <div class="col__">
              <h3>Phones</h3>
            </div>
            <div class="col__">
              <!-- Summary content when collapsed-->
              <div *ngIf="isPanelCollapsed(PANEL_NAMES.PHONES)">
                <div *ngFor="let val of phonesFA.value"
                     class="row row--left flexAlign--baseline recap">
                  <div class="recap__label">{{val?.numberType || '&mdash;'}}</div>
                  <div class="recap__value">
                    {{ val?.number | phone }}
                    <span *ngIf="val?.ext">EXT. {{val.ext}}</span>
                    <span *ngIf="val?.type">{{ val.numberType }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </mat-expansion-panel-header>

        <!-- Content When Expanded-->
        <div formArrayName="phones">
          <ng-container *ngFor="let phoneCtrl of phonesFA.controls; index as i">
            <div class="row  w-100 flexWrap--nowrap mt-0050">
              <div class="col col--gutter--3">
                <app-phone-form [formControlName]="i"></app-phone-form>
              </div>

              <div class="col col--gutterBtn right txt-18 color--gray">
                <button mat-icon-button
                        aria-label="Remove Phone"
                        (click)="removeFromFormArray(phonesFA, i)">
                  <mat-icon fontSet="fal"
                            fontIcon="fa-trash-alt">
                  </mat-icon>
                </button>
              </div>
            </div>
          </ng-container>
        </div>
        <div>
          <button type="button"
                  (click)="addToFormArray(phonesFA)"
                  class="btn btn--white pt-0075 pb-0075 w-100 mt-0075">
            <i class="fal fa-plus mr-0050"></i>
            Add Phone
          </button>
        </div>
      </mat-expansion-panel>

      <!-- Address panel -->
      <mat-expansion-panel *ngIf="selectedEntityType.addressEnabled"
                           (opened)="panelExpanded(PANEL_NAMES.ADDRESSES)"
                           (closed)="panelCollapsed(PANEL_NAMES.ADDRESSES)"
                           [expanded]="true">

        <mat-expansion-panel-header [collapsedHeight]="'fit-content'"
                                    [ngClass]="{ 'tempError':
                !formGroup.get('addresses').pristine && !formGroup.get('addresses').valid }">
          <div class="row w-100">
            <div class="col__">
              <h3>Addresses</h3>
            </div>
            <div class="col__">
              <!-- Summary content when collapsed-->
              <div *ngIf="isPanelCollapsed(PANEL_NAMES.ADDRESSES)">
                <div *ngFor="let val of addressesFA.value"
                     class="row row--left flexAlign--baseline recap">
                  <div class="recap__label">&mdash;</div>
                  <div class="recap__value">
                    {{val | address}}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </mat-expansion-panel-header>

        <!-- Content When Expanded-->
        <div formArrayName="addresses">
          <ng-container *ngFor="let addressCtrl of addressesFA.controls; index as i">
            <div class="row  w-100 flexWrap--nowrap mt-0050">
              <div class="col col--gutter--3">
                <app-address-form [formControlName]="i"></app-address-form>
              </div>

              <div class="col col--gutterBtn right txt-18 color--gray mt-0050">
                <button mat-icon-button
                        aria-label="Remove Address"
                        (click)="removeFromFormArray(addressesFA, i)">
                  <mat-icon fontSet="fal"
                            fontIcon="fa-trash-alt">
                  </mat-icon>
                </button>
              </div>
            </div>
          </ng-container>
        </div>
        <div>
          <button type="button"
                  (click)="addToFormArray(addressesFA, {country: defaultCountry})"
                  aria-label="Add Address"
                  class="btn btn--white pt-0075 pb-0075 w-100 mt-0075">
            <i class="fal fa-plus mr-0050"></i>
            Add Address
          </button>
        </div>
      </mat-expansion-panel>

      <!--- Default Tag Categories-->

      <mat-expansion-panel *ngIf="false"
                           [expanded]="true">
        <mat-expansion-panel-header [collapsedHeight]="'fit-content'">
          <div class="row w-100">
            <div class="col__">
              <h3 [ngClass]="{'color--red': tagsFG.get(tc.id).invalid }">{{tc.name}}</h3>
            </div>
            <div class="col__">

            </div>
          </div>

        </mat-expansion-panel-header>

        <div class="row  w-100 flexWrap--nowrap mt-0050">
          <div class="col col--gutter--3">
            <ng-container *ngIf="tc.multiselectable">
              <div class="mb-0050">
                <div class="row flexWrap--nowrap row--sep-if-stacked">
                  <app-apply-tag-multi-form class="col"
                                            [autoFocusDisabled]="true"
                                            [campaignId]="campaignId"
                                            [tagCategory]="tc"
                                            [formArray]="tagsFG.get(tc.id)"></app-apply-tag-multi-form>
                </div>
              </div>
            </ng-container>


            <ng-container *ngIf="!tc.multiselectable">
              <div class="mb-0050">
                <ng-container *ngFor="let control of tagsFG.get(tc.id).controls; index as i">
                  <div class="row flexWrap--nowrap row--sep-if-stacked">
                    <app-apply-tag-form [campaignId]="campaignId"
                                        [autoFocusDisabled]="true"
                                        tabindex="1"
                                        class="col"
                                        [required]="false"
                                        [tagCategory]="tc"
                                        [formControl]="control">

                    </app-apply-tag-form>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </div>

          <div class="col col--gutterBtn right txt-18 color--gray">
            <button mat-icon-button
                    aria-label="Reset Response"
                    (click)="tagsFG.get(tc.id).reset()">
              <mat-icon fontSet="fal"
                        fontIcon="fa-trash-alt">
              </mat-icon>
            </button>
          </div>
        </div>

      </mat-expansion-panel>


      <!-- Custom Creation Form -->
      <app-custom-form-renderer *ngIf="customFormGroup"
                                [form]="customFormGroup"
                                [entityType]="selectedEntityType"
                                [customForm]="selectedEntityTypeConfig?.creationCustomForm">
      </app-custom-form-renderer>

    </mat-accordion>

    <mat-divider class="mb-0100"></mat-divider>

    <div>
      <mat-progress-bar mode="determinate"
                        *ngIf="isSaving"
                        [value]="createProgress"
                        class="mb-0075"></mat-progress-bar>
      {{creationStatusMessage}}
    </div>


    <div class="flex flexJustify-end">
      <button type="button"
              [disabled]="isSaving || customFormGroup.invalid || !nameInfoFC.valid"
              (click)="onCreateAndAddAnother()"
              #createAddAnotherBtn
              class="btn btn--white capitalize w-100 w-auto--md">Create &amp; Add Another
        {{selectedEntityType?.nameSingular}}</button>
      <button type="button"
              [disabled]="isSaving || customFormGroup.invalid || !nameInfoFC.valid"
              (click)="onSubmitClick()"
              class="btn capitalize w-100 w-auto--md ml-0100--md mt-0075 mt-0--md">Create
        {{selectedEntityType?.nameSingular}}</button>
    </div>

  </ng-container>
</div>
